import React, { useRef, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import TradeRadarAlgoFbWelcome from "./TradeRadarAlgoFbWelcome/TradeRadarAlgoFbWelcome";
import TradeRadarAlgoFbHowItWorks from "./TradeRadarAlgoFbHowItWorks/TradeRadarAlgoFbHowItWorks";
import FullyAutomate from "../../../src/Images/landing/Traderadar-Algo/Fully-Automate.png";
import TradeCharge from "../../../src/Images/landing/Traderadar-Algo/trade.png";
import SupportTeam from "../../../src/Images/landing/Traderadar-Algo/support.png";
import BacktestStrategies from "../../../src/Images/landing/Traderadar-Algo/backtest.png";
import TradeRadarAlgoFbHowItWork from "../../../src/Images/landing/Traderadar-Algo/TradeRadarAlgoFbHowItWork.png";
import "./TradeRadarAlgoFb.css";
import { ApiUrlDomain } from "../Configration/Configrationnew";

function TradeRadarAlgoFb() {

    return (
        <>
            <main class="TradeRadarAlgoFbMain">
                <div className="stillwasting-section">
                    <div className="container">
                        <h5>Still wasting time in manual trading</h5>
                    </div>
                </div>
                < TradeRadarAlgoFbWelcome />
                <section className="traderadarAlgo-feature">
                    <div className="container">
                        <div className="traderadarAlgofeature-grid">
                            <div className="traderadarAlgofeature-group">
                                <div className="traderadarAlgo-panel">
                                    <img src={FullyAutomate}></img>
                                    <h3>Fully Automate</h3>
                                    <p>Fully automate your daily trading strategies at no cost</p>
                                </div>
                            </div>
                            <div className="traderadarAlgofeature-group">
                                <div className="traderadarAlgo-panel">
                                    <img src={TradeCharge}></img>
                                    <h3>Trade</h3>
                                    <p>Rs.10 Per order only (No platform fees)</p>
                                </div>
                            </div>
                            <div className="traderadarAlgofeature-group">
                                <div className="traderadarAlgo-panel">
                                    <img src={SupportTeam}></img>
                                    <h3>Support</h3>
                                    <p>Dedicated Support Team</p>
                                </div>
                            </div>
                            <div className="traderadarAlgofeature-group">
                                <div className="traderadarAlgo-panel">
                                    <img src={BacktestStrategies}></img>
                                    <h3>Backtest</h3>
                                    <p>Backtest your option strategies in seconds</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <TradeRadarAlgoFbHowItWorks />
                <section class="whychoose_section">
                    <div class="container">
                        <div class="section-heading center">Why <span>Choose</span> Moneysukh</div>
                        <div className="whychoose-grid">
                            <div className="whychoose-panel">
                                <h4>Flexible brokerage plans for Traders</h4>
                                <p>Triple benefits - Get instant pledge <br></br> benefits , trade at Rs 10 per order*,<br></br> complete tool kit.</p>
                            </div>
                            <div className="whychoose-panel">
                                <h4>Latest and secure Technology</h4>
                                <p>Cloud based & user-friendly platform <br></br>with latest features to help your<br></br> trading decisions.</p>
                            </div>
                            <div className="whychoose-panel">
                                <h4>Round the clock support</h4>
                                <p>Constant support and trade <br></br> with the help of dedicated<br></br> research.</p>
                            </div>
                        </div>
                        <div className="whychoose-img">
                            <img src={TradeRadarAlgoFbHowItWork}></img>
                        </div>
                    </div>
                </section>
                <section class="benefits_section">
                    <div class="container">
                        <div class="section-heading center">Benefits Of <span>Automated</span> Trading</div>
                        <div className="benefits-grid">
                            <div className="benefits-panel">
                                <h4>Trend</h4>
                                <p>Trades are executed on the basis of popular trend</p>
                            </div>
                            <div className="benefits-panel">
                                <h4>Index rebalancing</h4>
                                <p>Traders tend to focus on trades that’s have rebalancing effect</p>
                            </div>
                            <div className="benefits-panel">
                                <h4>Opportunity</h4>
                                <p>Track and trade the real opportunity arises in live markets</p>
                            </div>
                            <div className="benefits-panel">
                                <h4>Fast</h4>
                                <p>Trade execution at lightining speed</p>
                            </div>
                            <div className="benefits-panel">
                                <h4>Accuracy</h4>
                                <p>Trades get double checked to prevent any basic errors</p>
                            </div>
                            <div className="benefits-panel">
                                <h4>Emotions</h4>
                                <p>Automated trading makes your trading more decisive & emotions free</p>
                            </div>
                            <div className="benefits-panel">
                                <h4>Diversify</h4>
                                <p>Execute complex strategies with multiple time frame</p>
                            </div>
                            <div className="benefits-panel">
                                <h4>Cost</h4>
                                <p>Reduced transaction cost due to lack of human intervention</p>
                            </div>
                            <div className="benefits-panel">
                                <h4>Interface</h4>
                                <p>Simple and powerful UI</p>
                            </div>
                        </div>
                    </div>
                    <div className="bookdemo-section">
                        <div className="container">
                            <div className="bookdemo-inner">
                                <div className="bookdemo-grid">
                                    <h5> Book a free Demo</h5>
                                    <a href="#bnrfrm"> Apply Now</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </>
    );
}
export default TradeRadarAlgoFb;

